import { faCaretRight } from '@fortawesome/pro-solid-svg-icons/faCaretRight'
import { Flex, Text } from '@mantine/core'

import { Icon } from '@flecto/ui'

export type CellGroupProps = {
  category: string
}

export function CellGroup({ category }: CellGroupProps) {
  const categories = category.split(' > ')
  return (
    <Flex
      direction='row'
      mih={30}
      align='center'
      style={{ overflow: 'hidden', border: 0 }}
    >
      <Text c='gray.6' fz='sm' fw={500} truncate>
        {categories?.[0]}
      </Text>

      {categories?.[1] && (
        <>
          <Icon
            icon={faCaretRight}
            mt={1}
            mr={3}
            ml={2}
            color='gray.6'
            size='xs'
          />
          <Text c='gray.6' fz='sm' fw={500} truncate>
            {categories?.[1]}
          </Text>
        </>
      )}
    </Flex>
  )
}
